import { useState, useEffect, useRef } from "react";
import "./LanguageDropdown.css";

// Languages with flags
const languages = [
    { code: "en", label: "English", flag: "🇺🇸" },
    { code: "hi", label: "हिंदी", flag: "🇮🇳" },
    { code: "gu", label: "ગુજરાતી", flag: "🇮🇳" },
];

const LanguageDropdown = () => {
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState("en");
    const wrapperRef = useRef(null);

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const changeLanguage = (lang) => {
        const combo = document.querySelector(".goog-te-combo");
        if (!combo) return;

        combo.value = lang.code;
        combo.dispatchEvent(new Event("change"));
        setActive(lang.code);
        setOpen(false);
    };

    const activeLang = languages.find((l) => l.code === active);

    return (
        <div className="lang-wrapper" ref={wrapperRef}>
            {/* Google Translate Icon Button */}
            <button className="lang-btn" onClick={() => setOpen(!open)}>
                <img
                    src="https://www.gstatic.com/images/branding/product/1x/translate_24dp.png"
                    alt="Translate"
                    className="translate-icon"
                />
                <span className="active-flag">{activeLang?.flag}</span>
            </button>

            <ul className={`lang-dropdown ${open ? "show" : ""}`}>
                {languages.map((lang) => (
                    <li key={lang.code} onClick={() => changeLanguage(lang)}>
                        <span className="flag">{lang.flag}</span> {lang.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LanguageDropdown;
